import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectFieldNaturesFetched, {
	type SubjectFieldNaturesFetchedAction,
	type SubjectFieldNaturesFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectFieldNaturesFetched';
import subjectFieldNaturesFetchFailed, {
	type SubjectFieldNaturesFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectFieldNaturesFetchFailed';
import type FetchSubjectFieldNatures from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectFieldNatures';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectFieldNaturesFetchedAction | SubjectFieldNaturesFetchFailedAction;

export default (_query: FetchSubjectFieldNatures) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectFieldNaturesFetchedPayload>(
				`${parameters.api.host}/api/enums/subject-field-natures`,
			);

			const action = subjectFieldNaturesFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectFieldNaturesFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
